import type { Translations } from '../config'

// More complex formatting, with links: https://formatjs.io/docs/react-intl/components#rich-text-formatting

export const enGB: Translations = {
  'page.home.title': 'Mind the Coin | Create Account',
  'page.home.description': 'Sign up for Mind the Coin customers',
  'page.status.title': 'Mind the Coin | Customer sign-up | Current status',
  'page.additionalInformation.title': 'Mind the Coin | Customer sign-up | Additional Information',
  'login.chaveMovel.info':
    'The digital mobile key can be activated by residents in Portugal. Activation instructions are available on the <link>government website</link>.',
  'login.chaveMovel.infoLink':
    'https://eportugal.gov.pt/en/servicos/ativar-a-chave-movel-digital',
  'login.data.whyDoWeCollectTitle': 'Why do we collect your data?',
  'login.data.whyDoWeCollect':
    'The data we collect is processed only in the context of <link>Law 83/2017</link> and it will never be used for marketing purposes or shared with third parties. According to Article 24, point 1, the collection of the following data is mandatory:',
  'login.data.whyDoWeCollectLink':
    'https://dre.pt/dre/legislacao-consolidada/lei/2017-108024643',
  'login.data.photo': 'Photo',
  'login.data.fullName': 'Full name',
  'login.data.signature': 'Signature',
  'login.data.birthDate': 'Birth date',
  'login.data.nationality': 'Nationality',
  'login.data.documentEntity':
    'Type, number, validity and entity that emitted the identity document',
  'login.data.nif':
    'Fiscal id number',
  'login.data.occupation': 'Occupation and employer, if applicable',
  'login.data.address':
    'Permanent residence (when applicable)',
  'login.data.placeOfBirth': 'Place of birth',
  'login.data.otherNationalities':
    'Other nationalities not present in the identity document',
  'login.data.phoneNumberInfo':
    'We also collect your phone number so that you can use our machines.',
  'login.main.chaveMovel':
    'Please select an option below in order to proceed with the registration process.',
  'login.main.cookieInfo':
    '<b>Cookie notice:</b> By continuing, you agree that we store in your browser information about your current authentication state. This will be deleted once you close the window, and you will need to login again to see the state of your registration.',
  'login.gov.buttonTitle': 'Gov.pt Login',
  'login.form.buttonTitle': 'Form',
  'status.inProgress.text': 'We are now verifying your identity. You will receive a text message as soon as this is complete.',
  'status.inProgress.secondary': 'The average waiting time is two hours, but it may take up to one day.',
  'status.verified.text': 'Your identity has been confirmed!',
  'status.verified.iconTitle': 'Identity confirmed',
  'status.verified.secondary': 'You can use <b>Mind the Coin</b> services without limit with your phone number.',
  'status.error.text': 'There was an error while verifying your identity.',
  'status.error.iconTitle': 'Error verifying identity',
  'status.error.secondary': 'For more information, please reach out to our customer support line at <b>{email}</b> or by phone at <b>{phoneNumber}</b>.',
  'status.apiError.text': 'We were unable to load the current status of your identify verification. Please reload the page.',
  'status.apiError.iconTitle': 'Error when loading status',
  'status.apiError.secondary': 'If the problem persists, you can reach out to our customer support line at <b>{email}</b> or by phone at <b>{phoneNumber}</b>.',
  'moreInfo.text': 'Thank you for registering with us. We just need a few more details from you.',
  'moreInfo.fields.occupation': 'Occupation*',
  'moreInfo.fields.occupation.help': 'Please refer to your last occupation if you are currently retired or unemployed',
  'moreInfo.fields.employer': 'Employer*',
  'moreInfo.fields.employer.help': 'Please also include last employer if you are currently retired or unemployed',
  'moreInfo.fields.businessArea': 'Industry*',
  'moreInfo.fields.businessArea.help': 'Please select your field of work. If unemployed or retired, refer to the last industry you were involved in.',
  'moreInfo.fields.businessRevenue': 'Annual Personal Income*',
  'moreInfo.fields.businessRevenue.help': 'Choose the range that best represents your yearly income.',

  'moreInfo.fields.highRiskCountry': 'High risk business countries',
  'moreInfo.fields.highRiskCountry.help': 'If you or your place of work maintain any business ties or affiliations with any of these high-risk countries, please identify them.',

  'moreInfo.fields.relationshipPurpose': 'Registration goal*',
  'moreInfo.fields.relationshipPurpose.help': 'Why are you registering with us?',
  'moreInfo.fields.placeOfBirth': 'Place of birth*',
  'moreInfo.fields.placeOfBirth.help': 'Place where you were born',
  'moreInfo.fields.otherNationalities': 'Other nationalities',
  'moreInfo.fields.otherNationalities.help': 'If applicable',
  'moreInfo.fields.otherNationalities.info': 'Nationalities that are not included in the identity document linked to the Mobile Digital Key (if applicable).',
  'moreInfo.fields.address.info': "Your current address. Fill this only if it's different from your fiscal address.",
  'moreInfo.fields.address.title': 'Non-fiscal address',
  'moreInfo.fields.address.line1': 'Line 1',
  'moreInfo.fields.address.line2': 'Line 2',
  'moreInfo.fields.address.postalCode': 'Postcode',
  'moreInfo.fields.address.city': 'City',
  'moreInfo.fields.address.country': 'Country',
  'moreInfo.buttons.submit': 'Submit',
  'moreInfo.status.success': "All done! You'll be sent to a page where you can follow the status of your registration in {countdown, plural, one {# second} other {# seconds}}.",
  'moreInfo.status.error': 'There was an error when sending your data. Please try again later.',
  'validation.stringLength': 'The field "{fieldName}" must have between {min} and {max} characters.',
  'form.fields.countryDropdown.multiplePlaceholder': 'Pick one or more countries',
  'form.fields.countryDropdown.singlePlaceholder': 'Pick a country',
  'form.fields.countryDropdown.emptySearch': 'Country not found. Is it written in English?',
  'form.fields.businessAreaDropdown.multiplePlaceholder': 'Pick one or more business areas',
  'form.fields.businessAreaDropdown.singlePlaceholder': 'Pick a business area',
  'form.fields.businessAreaDropdown.emptySearch': 'Business area not found. Is it written in English?',
  'form.fields.businessRevenueDropdown.multiplePlaceholder': 'Select your personal annual income',
  'form.fields.businessRevenueDropdown.singlePlaceholder': 'Select your personal annual income',
  'form.fields.businessRevenueDropdown.emptySearch': 'Revenue range not found', 
  'form.fields.highRiskCountryDropdown.singlePlaceholder': 'Select one or more countries',
  'form.fields.highRiskCountryDropdown.multiplePlaceholder': 'Select one or more countries',
  'form.fields.highRiskCountryDropdown.emptySearch': 'Not found', 
  'form.fields.mandatory': 'Mandatory field',  
  'authorisation.notAuthorised.title': 'Not authorised',
  'authorisation.error': ' There was an error when logging you in. Please, go back and try again. If the problem persists, contact us in {email} or via phone by {phoneNumber}.',
  'common.close': 'Close',
  'common.logout': 'Log out',
  'common.moreInfo': 'More information',
  'common.customerServiceEmail': 'support@mindthecoin.com',
  'common.customerServicePhoneNumber': '912 125 732',
  'common.backToHome': 'Back to home',
  'errors.404.title': 'Page not found',
  'errors.404.description': 'The page you are looking for does not exist. Please go back to the homepage and try again.',
}


export const businessAreasEnGB = [
  'Accounting and Finance',
  'Advertising and Marketing',
  'Aerospace and Defense',
  'Agriculture and Farming',
  'Arts and Entertainment',
  'Automotive',
  'Biotechnology',
  'Betting & Gambling',
  'Chemicals',
  'Construction',
  'Consumer Goods and Services',
  'Education',
  'Energy and Utilities',
  'Engineering Services',
  'Environmental Services',
  'Fashion and Apparel',
  'Food and Beverage',
  'Government and Public Administration',
  'Healthcare and Social Assistance',
  'Hospitality and Tourism',
  'Information Technology and Services',
  'Insurance',
  'Legal Services',
  'Manufacturing',
  'Media and Broadcasting',
  'Mining and Metals',
  'Nonprofit',
  'Pharmaceuticals',
  'Real Estate',
  'Retail',
  'Sports',
  'Telecommunications',
  'Transportation and Logistics',
  'Veterinary Services',
  'Virtual Assets and Cryptocurrency',
  'Wholesale Trade'
];
